import './SearchInput.scss';

type SearchInputCallbacks = {
    onChange: (searchString: string) => void,
}

export class SearchInput {

      private readonly root: HTMLDivElement;
      private readonly callbacks: SearchInputCallbacks;

      constructor(root: HTMLDivElement, callbacks: SearchInputCallbacks) {
          this.root = root;
          this.callbacks = callbacks;
          this.render();
      }

      private render(): void {
          this.root.innerHTML = this.getHTML();
          this.root.querySelector('.search-input').addEventListener('input', (event: Event) => {
              this.callbacks.onChange((event.target as HTMLInputElement).value);
          });
      }

      private getHTML(): string {
          return `
              <div class="search-input-container">
                  <input type="text" class="search-input" placeholder="">
                  <div class="search-input-icon-magnitude"></div>
              </div>
          `;
      }
}
